<template>
  <div>
    <el-form-item :label="labelText(zdItem.label)">
      <el-date-picker
        style="float: left;"
        :format="dateFormat"
        :value-format="dateFormat"
        :disabled="setupDisable()"
        type="date"
        :placeholder="$t('view.data_placeholder')"
        v-model="zdItem.value"
        @change="dateChange"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item v-if="showShelflifeNumber()" :label="$t('content.shelflife_number')">
      <el-tag style="float: left;" >{{localShelflifeNumber}}</el-tag>
    </el-form-item>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDDate", 
  inject: ['getCurrentDataMethod'],
  props: {
    zdId: {
      type: String,
      required: true,
    },
    shelflifeNumber: {
      type: Number,
      default: 24,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  data() {
    return {
      dateFormat: "yyyy-MM-dd",
      localShelflifeNumber: this.shelflifeNumber, // 初始化本地数据属性
    };
  },
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    zdFormattedValue: {
      get() {
        return this.zdItem.value || ""; // 获取输入框的值
      },
      set(value) {
        
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
  },
  created() {
    this.dateFormatChange();
    // this.shelflifeNumber = this.getCurrentDataMethod().shelflifeNumber; // 移除直接修改 prop
    // this.localShelflifeNumber = this.getCurrentDataMethod().shelflifeNumber; // 初始化本地数据属性
    
    // 从getCurrentDataMethod获取shelflifeNumber并更新localShelflifeNumber
    const currentData = this.getCurrentDataMethod();
    if (currentData && currentData.shelflifeNumber !== undefined) {
      this.localShelflifeNumber = currentData.shelflifeNumber;
      // 同时通过事件通知父组件更新，如果需要的话
      this.$emit('update:shelflifeNumber', currentData.shelflifeNumber);
    }
    
    console.log("created:", this.zdItem.label);
    
    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },
  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    showShelflifeNumber(){
      return this.zdItem.label === "Manufacuture Date";
    },
    dateFormatChange(){
      const currentData = this.getCurrentDataMethod();
      let language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
      let val = "yyyy-MM-dd"
      
      if(language == "en"){
        val = "yyyy-MM"
      }
      this.dateFormat = val
    },
    dateChange(val){
      //console.info('val:',val)
      // //console.info('this.zdItem.label:',this.zdItem.label)
      if(this.zdItem.label==="Manufacuture Date"){
        //console.info('setItem ManufacutureDate:',val)
        
        // 同步更新到currentData
        const currentData = this.getCurrentDataMethod();
        try {
          if (currentData) {
            currentData.manufacutureDate = val;
          }
        } catch (error) {
          console.warn('无法更新currentData中的制造日期:', error);
        }
        
        // shelflife_number 默认 24
        // let shelflife_number = parseInt(localStorage.getItem("shelflife_number") || 24)
        let shelflife_number = this.localShelflifeNumber; // 使用 props 传递的 shelflifeNumber

        console.info('shelflife_number:',shelflife_number)
        let expirationDate = new Date(val);
        expirationDate.setMonth(expirationDate.getMonth() + shelflife_number);
        let expirationDateStr = expirationDate.toISOString().split('T')[0];
        //console.info("expirationDateStr:" + expirationDateStr);
        ["tab1_expiration_date_id_date_7","tab1_expiration_date_id_date_8", "tab1_expiration_date_id_date_10"].forEach(id => {
          this.zdUpdateComponent({
            id,
            field: "value",
            value: expirationDateStr
          });
        })
      }

      this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: val,
        });
    },
    
    /**
     * 处理页面状态变化
     */
    handlePageStatusChange() {
      // console.info("ZDDate: Page status changed to", pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    /**
     * 处理标签页变化
     */
    handleTabChanged() {
      // console.info("ZDDate: Tab changed to", data.tabName, "with status", data.pageStatus, "for component", this.zdId);
      
      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    
    /**
     * 设置组件是否禁用
     */
    setupDisable() {
      const pageStatus = this.pageStatus;
      
      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }
      
      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    }
  },
};
</script>
